export default "__VITE_ASSET__DzOZQs3k__"